import React from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from 'react-bootstrap';
import { Alert, Button, Modal } from '@canaveral/components';
import styles from './FileForm.scss';

const propTypes = {
  error: PropTypes.string,
  filename: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  progress: PropTypes.string,
  saving: PropTypes.bool,
  onReturn: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

const defaultProps = {
  error: undefined,
  progress: undefined,
  saving: undefined,
};

class FileForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
    };
  }

  componentDidUpdate(prevProps) {
    const { onReturn, saving } = this.props;
    const wasSaving = prevProps.saving;

    if (!saving && wasSaving) {
      onReturn();
    }
  }

  onChange = e => this.setState({
    [e.target.name]: e.target.value,
  })

  onSubmit = (e) => {
    const { filename, onSubmit } = this.props;

    onSubmit({ filename, name: this.state.name || this.props.name });
    e.preventDefault();
  }

  render() {
    const {
      error, filename, saving, onReturn, progress,
    } = this.props;

    const name = this.state.name || this.props.name;

    if (progress) {
      return (
        <Modal.Body>
          <ProgressBar active bsStyle="success" now={progress} />
        </Modal.Body>
      );
    }

    return (
      <form onSubmit={this.onSubmit}>
        <Modal.Body>
          {error && (
            <Alert context="danger">
              {error}
            </Alert>
          )}
          <div className={styles.control}>
            <label>File Name</label>
            <input
              readOnly
              type="text"
              name="filename"
              value={filename}
            />
          </div>
          <div className={styles.control}>
            <label>Title</label>
            <input
              type="text"
              name="name"
              value={name}
              onChange={this.onChange}
              required
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            size="sm"
            context="neutral"
            disabled={saving}
            onClick={onReturn}
          >
            Back
          </Button>
          <Button
            size="sm"
            type="submit"
            loading={saving}
            context="positive"
          >
            {saving ? 'Saving...' : 'Save'}
          </Button>
        </Modal.Footer>
      </form>
    );
  }
}

FileForm.propTypes = propTypes;
FileForm.defaultProps = defaultProps;

export default FileForm;
